import { Link } from "react-router-dom";
import { ChevronLeft, CircleCheckBig } from "lucide-react";

export default function OrderCard({ order,tab ,Icon  }) {
  return (
    <div className="orderCardLayout">
      <div className="ocheader">
        <p className="orderStatus">
          {/* <CircleCheckBig size={20} color="#d6d6d6" /> */}
           {Icon && <Icon size={20} color="#d6d6d6" />}
           {tab.label}
        </p>

        <Link
          to={`/dashboard/order-detail/${order.id}`}
          className="mt-3 inline-block px-4 py-2 bg-blue-600 text-white rounded"
        >
          <p className="orderdetailSHow">
            جزئیات بیشتر
            <ChevronLeft size={20} color="#d6d6d6" />
          </p>
        </Link>
      </div>

      <div className="orderCard">
        <div className="orderSpeficicHeader">
          <div className="trackingCode">
            <p>کد سفارش:</p>
            <p className="orderData pr">CDCP-{order.id}</p>
          </div>

          <div className="amountTotalPaid">
            <p className="orderData pr">
              {Number(
                order.amount - order.discount - order.wallet,
              ).toLocaleString()}
              <span className="currency"> تومان</span>
            </p>
          </div>
        </div>

        <div className="orderSpeficic">
          <div className="orderAmount brl">
            <div>
              <div className="amountReg">
                <div className="dateOrder brl">
                  <p>تاریخ سفارش:</p>
                  <p className="orderData pr">{order.order_date}</p>
                </div>

                <div className="sendType pr brl">
                  <p>نوع ارسال :</p>
                  <p className="orderData pr">{order.sendItem}</p>
                </div>

                <div className="shipping">
                  <p> نوع پرداخت:</p>
                  <p className="orderData pr">
                    {order.method}
                    {order.gateway && (
                      <span className="gatewayTitle">({order.gateway})</span>
                    )}
                  </p>
                </div>
              </div>

              {/* <div className="amountTotal">
              <div className="amountTotalPaid">
                <p>مبلغ پرداخت شده:</p>
                <p className="orderData pr">
                  {Number(
                    order.amount - order.discount - order.wallet,
                  ).toLocaleString()}
                  تومان
                </p>
              </div>
            </div> */}
            </div>
          </div>
        </div>

    
      </div>
    </div>
  );
}
